import "./Layout.css";


export default function Layout({ children }) {
  return (
    <div className="grid-container">
      <main className="main-content">{children}</main>
    </div>
  );
}
